import { Injectable, NgZone, ElementRef } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { ResizeSensor } from 'css-element-queries';

export class ResizedEvent {
  constructor(
    readonly element: ElementRef,
    readonly newWidth: number,
    readonly newHeight: number,
    readonly oldWidth: number,
    readonly oldHeight: number
  ) {}
}

@Injectable()
export class ResizedService {
  private readonly _resized$ = new Subject<ResizedEvent>();

  private element: ElementRef;
  private oldWidth: number;
  private oldHeight: number;

  resized$: Observable<ResizedEvent>;

  constructor(private zone: NgZone) {
    this.resized$ = this._resized$.asObservable();
  }

  init(element: ElementRef) {
    this.element = element;
    this.zone.runOutsideAngular(() => {
      new ResizeSensor(this.element.nativeElement, _ => this.onResized()); // tslint:disable-line
      this.onResized();
    });
  }

  private onResized() {
    const newWidth = this.element.nativeElement.clientWidth;
    const newHeight = this.element.nativeElement.clientHeight;

    if (newWidth === this.oldWidth && newHeight === this.oldHeight) {
      return;
    }

    const event = new ResizedEvent(this.element, newWidth, newHeight, this.oldWidth, this.oldHeight);

    this.oldWidth = this.element.nativeElement.clientWidth;
    this.oldHeight = this.element.nativeElement.clientHeight;

    this._resized$.next(event);
  }
}
